import { render } from "./LoanDetailConfirmation.vue?vue&type=template&id=e8fec29a"
import script from "./LoanDetailConfirmation.vue?vue&type=script&lang=js"
export * from "./LoanDetailConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
